@if (orchestratorViewModel?.allViewModelErrorsBuildedList?.length > 0) {
  <div class="validation-panel">
    <div class="validation-panel-left">
      <div class="validation-panel-icon">
        <svg-icon key="warning"></svg-icon>
      </div>
    </div>
    <div class="validation-panel-content" [class.expanded]="itemToShow > 1">
      @if (orchestratorViewModel?.allViewModelErrorsBuildedList?.length > 1) {
        <div class="validation-panel-top">
          <div class="validation-panel-title">
            {{
            ('std_Validation_More_Error' | NTSTranslate:
            [orchestratorViewModel?.allViewModelErrorsBuildedList?.length.toString()])
            }} @if (orchestratorViewModel?.allViewModelErrorsBuildedList.length > (itemToShow + 1)) {
            <a [routerLink]="[]" queryParamsHandling="merge" (click)="showMore()"
              role="button"
              class="validation-panel-bottom-bar-show-button">{{'std_Validation_Show_All_Error' |
            NTSTranslate}}</a>
          }
        </div>
      </div>
    }
    <div class="validation-panel-bottom"
      [class.one-validation]="orchestratorViewModel?.allViewModelErrorsBuildedList.length == 1">
      @switch (orchestratorViewModel?.allViewModelErrorsBuildedList.length) {
        @case (1) {
          <div class="validation-panel-message">
            <div class="validation-panel-message-text">
              {{ orchestratorViewModel?.allViewModelErrorsBuildedList[0].message }}
              @if (orchestratorViewModel?.allViewModelErrorsBuildedList[0].propertyName && orchestratorViewModel?.allViewModelErrorsBuildedList[0].objectName) {
                <a
                  [routerLink]="[]"
                  queryParamsHandling="merge"
                  (click)="focusMessage($event, $safeNavigationMigration(orchestratorViewModel?.allViewModelErrorsBuildedList[0]))"
                  class="validation-panel-goto">
                  {{'std_Validation_Goto' | NTSTranslate}}
                </a>
              }
            </div>
          </div>
        }
        @default {
          @for (error of orchestratorViewModel?.allViewModelErrorsBuildedList.slice(0, itemToShow); track error) {
            <div class="validation-panel-message"
              >
              <div class="validation-panel-message-text">
                - {{ error.message }}
                @if (error.propertyName && error.objectName) {
                  <a
                    [routerLink]="[]"
                    queryParamsHandling="merge"
                    (click)="focusMessage($event, error)"
                    role="button"
                    class="validation-panel-goto">
                    {{'std_Validation_Goto' | NTSTranslate}}
                  </a>
                }
              </div>
            </div>
          }
        }
      }
      <div class="validation-panel-bottom-bar">
        @if (orchestratorViewModel?.allViewModelErrorsBuildedList.length == itemToShow && itemToShow != defaultItemToShow) {
          <a [routerLink]="[]" queryParamsHandling="merge" (click)="showLess()"
            role="button" class="validation-panel-bottom-bar-show-button">{{'std_Validation_Show_Less_Error' |
          NTSTranslate}}</a>
        }
      </div>
    </div>
  </div>
  <div class="validation-panel-right">
    <nts-text-button
      icon="help-circle"
      [title]="'std_Validation_MoreInformation' | NTSTranslate"
    (onClicked)="moreInformation($safeNavigationMigration(orchestratorViewModel?.allViewModelErrorsBuildedList))"></nts-text-button>
    <nts-text-button
      icon="cancel"
    (onClicked)="orchestratorViewModel.eventDispatcher.onValidationBarCollapsed.next(true)"></nts-text-button>
  </div>
</div>
}